import { atom } from "jotai";

export const isConnectingEdgeInProgressAtom = atom<boolean>(false);
isConnectingEdgeInProgressAtom.debugLabel = "isConnectingEdgeInProgressAtom";
